export function getRouteBounds(...routes) {
    let north;
    let south;
    let west;
    let east;
    for (const route of routes) {
        for (const path of route.paths) {
            for (const [lon, lat] of path.coordinates) {
                if (north === undefined || north < lat)
                    north = lat;
                if (south === undefined || south > lat)
                    south = lat;
                if (west === undefined || west > lon)
                    west = lon;
                if (east === undefined || east < lon)
                    east = lon;
            }
        }
    }
    return [west, south, east, north];
}
export function debounceCall(time, fn) {
    let timeout;
    return (...args) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => fn(...args), time);
    };
}
export function createTemplateFactory(html) {
    const template = document.createElement('template');
    template.innerHTML = html;
    return () => template.content.cloneNode(true);
}
